@if (visible$ | async) {
<label [for]="for()" class="col-form-label label-quantity">{{ translationKey() | translate }}</label>
}
